import React from 'react';
import { ButtonGroup, Container, Row, Col, FormGroup, Label, Input } from 'reactstrap';
import ButtonAction from './ButtonAction';
import ImageProcessingForm from './ImageProcessingForm';
import { matchesSimpleString } from '../helpers/Validations';

export default class UploadItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      imageForm: false,
      parentProcess: this.props.processImages,
      process: true,
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.cover && this.props.cover) {
      this.props.file.imageSettings.height = 1800;
      this.props.file.imageSettings.width = 1800;
    } else if (prevProps.cover && !this.props.cover) {
      this.props.file.imageSettings.height = null;
      this.props.file.imageSettings.width = null;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.processImages !== this.state.parentProcess) {
      this.props.file.imageSettings.process = nextProps.processImages;
      this.setState({
        process: nextProps.processImages,
        parentProcess: nextProps.processImages,
      });
    }
  }

  toggleImageForm = (e) => {
    e.preventDefault();
    this.setState({ imageForm: !this.state.imageForm });
  }

  toggleImageProcessing = (e) => {
    e.preventDefault();
    this.props.file.imageSettings.process = !this.state.process;
    this.setState({ process: !this.state.process });
  }

  shouldEnableImageButton() {
    return this.props.file.isImage;
  }

  // don't process SVGs
  processableImage() {
    return this.props.file.isImage && this.props.file.type !== 'image/svg+xml';
  }

  shouldDisplayImageSettings() {
    return this.state.imageForm;
  }

  setImageProcessValues = (attr, val) => {
    this.props.file.imageSettings[attr] = val;
  }

  canDisplayThumb(file) {
    return file.isImage && (file.type === 'image/jpeg' || file.type === 'image/png');
  }

  classList() {
    const list = ['list-group-item'];
    if (!matchesSimpleString(this.props.file.name)) {
      list.push('file-name-warning');
    }
    return list.join(' ');
  }

  columnSize(index) {
    if (!this.props.colSizes) {
      return [3, 4, 5][index];
    }
    return this.props.colSizes[index];
  }

  render() {
    const { file, removeFile } = this.props;
    return (<li className={this.classList()}>
      <Container className="upload-item">
        <Row>
          <Col md={this.columnSize(0)} className="upload-item-preview">
            {this.canDisplayThumb(file) ?
              <img
                className="img-thumbnail"
                style={{ maxWidth: '100%', maxHeight: '100px' }}
                src={file.preview}
              /> :
              <i className="fa fa-file" />
            }
          </Col>
          <Col md={this.columnSize(1)} className="upload-item-name">
            {file.name}
          </Col>
          <Col md={this.columnSize(2)} className="upload-item-remove">
            <div className="btn-group-padded">
              {file.isImage && this.props.canSetCover ?
                <ButtonAction
                  size="sm"
                  color={this.props.cover ? 'success' : 'warning'}
                  className="pull-md-right"
                  title="Set as cover"
                  icon="fa-book"
                  action={() => this.props.changeCover(file.name)}
                >
                  <span className="hidden-md-down">
                    {this.props.cover ? 'Cover' : 'Set cover'}
                  </span>
                </ButtonAction>
                : null }
              {this.processableImage() ?
                <ButtonAction
                  disabled={!this.shouldEnableImageButton()}
                  size="sm"
                  icon="fa-cog"
                  color="secondary"
                  title="image settings"
                  action={this.toggleImageForm}
                /> : null }
              <ButtonAction size="sm" title="remove upload" color="danger" icon="fa-remove" action={removeFile} />
            </div>
          </Col>
        </Row>
        {this.shouldDisplayImageSettings() ?
          <ImageProcessingForm
            className="asset-image-processing"
            enabled={this.state.process}
            dimensionsCallback={this.setImageProcessValues}
            cover={this.props.cover}
          >
            <FormGroup row>
              <Container>
                <Row>
                  <Col md="6">
                    <h4>{file.name} settings</h4>
                  </Col>
                  <Col md="6">
                    <FormGroup check className="float-md-end">
                      <Label check>
                        <ButtonAction
                              size="sm"
                              icon={this.state.process ? 'fa-check' : 'fa-remove'}
                              color={this.state.process ? 'success' : 'warning'}
                              action={this.toggleImageProcessing}
                            >
                              Process Image
                            </ButtonAction>
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </Container>
            </FormGroup>
          </ImageProcessingForm> : null }
      </Container>
    </li>);
  }
}
